import { render, staticRenderFns } from "./BlacklistNumberForm.vue?vue&type=template&id=58f2bd8a"
import script from "./BlacklistNumberForm.vue?vue&type=script&lang=js"
export * from "./BlacklistNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports